import React, { useState, useRef, useEffect } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import ListingComponent from '../../components/ListingComponent';
import { useParams } from  'react-router-dom'
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Multiselect from 'multiselect-react-dropdown';


const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const navigate = useNavigate();
  const params = useParams();
  const [updateApi] = getApi('updateUser');
  const [fetchClustersApi] = getApi('clusters');
  const [cluster, setCluster] = useState(null);
  const [clusters, setClusters] = useState([]);

   useEffect(()=>{
    fetchClusters();
  }, [])

  const fetchClusters = async () => {
    try {
      let response = await fetchClustersApi({params, filters: {branch_id: props.branch_id}, fields: 'options'}).unwrap();
      setClusters(response.data.clusters)
    } catch {
      toast.error("Clusters not found")
    }
  }

  const handleClusterMap = async () => {
    if(cluster == null) {
      toast.error("Please select Cluster.")
      return
    }
    try {
      let parameter = {
        id: params.id,
        user: {
          cluster_user_mappings_attributes: [{cluster_id: cluster, user_id: params.id, company_id: 2, is_valid: true}]
        }
      }
      await updateApi(parameter).unwrap();
      window.location.reload();
      // dispatch(resetQueryParams())
    } catch {
      toast.error("Something went wrong.")
    }
  }
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'cluster',
      value: (row) => row.cluster.name,
    },
    {
      ...defaultHeaderConfig,
      label: 'Valid',
      value: (row) => row.is_valid ? "True" : "False",
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at'
    },
  ]

  const onClusterSelect = (_, selectedItem) => {
    setCluster(selectedItem.id)
  }

  return <>
  <div className="row">
    <div className="col-md-2 mx-2">
      <label htmlFor="zones" className='form-label'>Select Clusters</label>
      <Multiselect
       id="zones"
       options={clusters}
       selectedValues={props.clusters}
       onSelect={onClusterSelect}
       placeholder='Select from options'
       displayValue={'name'}
       showArrow={true}
       customArrow={true}
       singleSelect={true}
       avoidHighlightFirstOption={true}
       disablePreSelectedValues={true}
     />
   </div>
    <div className="col-md-2 my-3">
      <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleClusterMap}> Map Cluster </button>
    </div>
 </div>
  <ListingComponent
    key={"PAGES.WorkOrdersListingPage.name"}
    listingMutation={getApi('clusterUserMappings')}
    contentHeading="Cluster-User Mappings"
    headers={headers}
    params={{id: params.id}}
    recordsKey="cluster_user_mappings"
    hideSearch={true}
  /></>
};

export default Listing;
